import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import * as actions from '../../actions/index';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment, { now } from 'moment'
import LayoutHeader from './Header'
import AdminNavigation from './AdminNavigation';
import AlumniNavigation from './AlumniNavigation';
import './layout.css';
import { Modal , Button, Row, Col, Input, Form, Icon, message,Card,Select, Upload, notification, Dropdown} from 'antd';
import InputMask from 'react-input-mask'
import { object } from 'prop-types';
import { history } from '../../container/History';


const FormItem = Form.Item;
const { Dragger } = Upload;

class SparkOpportunityForm extends Component {
    constructor(props){
        super(props)
        this.state = {
            isShowNST_modal: false,
            isShowSPARK_OpportunityModal: false,
            picture: '',
            defaultFileList:'',
            imageUrl:'',
            disable:true,
            briefDescription_textLength: 0,
            IsFutureDate: false,
            CustomDateErrMsg: '',
            ComputerType: ['PC', 'Phone', 'Tablet'],
            AreaOfConcern: ['Dashboard', 'Alumni Search', 'Advanced Search', 'Profile', 'Membership Number', 'Awards', 'Downloads', 'Printing'],
            typeOf_Issue: ['Enhancement', 'Wrong Information', 'Can\'t Update', 'Other'],
        }
    }

    getTextCount = e => {
        let stringLengh = e.target.value.length
        this.setState({
            briefDescription_textLength : stringLengh
        })
    }

    handleSubmit = e => {
        e.preventDefault();
        if (!this.state.IsFutureDate){
            this.props.form.validateFieldsAndScroll((err, values) => {
                
                if (!err) {
                    // this.Export2Word('Spark-Opportunity-form-div', 'Spark', this.state.imageUrl)
                    // this.convertToDoc('Spark-Opportunity-form-div', 'Spark', this.state.imageUrl) // this function commented to test the API 
        
                    this.props.actions.sentSparkOpportunityFormToMail(values, this.state.imageUrl ? this.state.imageUrl : '')
                    history.push('/alumni-dashboard')
                }
            })
            
        }
      }

      CheckTheDate = (value, i) => {

        console.log("CheckTheDate " + value) 
        var today = moment().format('MM/DD/YYYY'),
        enteredDate = value.split("/");

        enteredDate = new Date(enteredDate[2], enteredDate[1] - 1, enteredDate[0]).getTime();
        let isFuturedate =  moment().isBefore(value);
        let isCurrentDate = moment(today).isSame(value);

        if (isFuturedate) {
           return this.setState({
                IsFutureDate: true,
                CustomDateErrMsg: 'The date Should not be in the future!'
            })
        } 
        if (isCurrentDate) {
            return this.setState({
                IsFutureDate: true,
                CustomDateErrMsg: 'Date Of Birth should not be as a current Date!'
            })
        }
        else {
            return this.setState({
                IsFutureDate: false,
                CustomDateErrMsg: ''
            })
        }

      }

      componentWillReceiveProps = (nextprops) => {
        if (this.props.mailSent !== nextprops.mailSent) {
            if(nextprops.mailSent){
             this.props.form.resetFields();
         }
        }
      }

      renderComputerType = () => {
        return this.state.ComputerType.map((type, index) => {
            return (
                <option key={type} value={type}>{type}</option>
            )
        })
      }
      renderAreaOfConcern = () => {
        return this.state.AreaOfConcern.map((type, index) => {
            return (
                <option key={type} value={type}>{type}</option>
            )
        })
      }
      renderTypeOf_Issue = () => {
        return this.state.typeOf_Issue.map((type, index) => {
            return (
                <option key={type} value={type}>{type}</option>
            )
        })
      }

    render(){
        const { getFieldDecorator } = this.props.form;
        const { TextArea } = Input;

        return <Modal
        // title="Spark Opportunity Form"
        centered
        // closable={false}
        onOk={this.props.handleSubmitHandler}
        onCancel={this.props.hideSPARK_OpportunityModalHandler}
        className="add-membership-modal"
        visible={this.props.isShowSPARK_OpportunityModal}
        footer={false}
    >
        {/* <Row type="flex" justify="center" align="center"> */}
            <div style={{display: 'flex', justifyContent:'center'}}>
                <img src='../Spark Opportunity.png' style={{ width: '30%' }} />
            </div>
        {/* </Row> */}
        <Form layout="vertical" onSubmit={this.handleSubmit}>
            <Row gutter={48} type="flex" justify="center" align="center">
                <Col span={12}>
                    <FormItem
                        label="Name"
                        hasFeedback
                        style={{padding: '0px'}}
                    >
                        {getFieldDecorator('name', {
                            rules: [{ required: true, message: 'Enter Name!' }],
                        })(
                            <Input maxLength={50} 
                            // placeholder="Name"
                             />
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem
                        label="Date"
                        validateStatus={this.state.IsFutureDate ? "error"  : undefined}
                        hasFeedback
                        help={this.state.CustomDateErrMsg ? this.state.CustomDateErrMsg : undefined}
                        style={{padding: '0px'}}
                    >
                        {getFieldDecorator('date', {
                            initialValue: '',
                            rules: [
                                { required: true, message: 'Enter the date!' },
                                {
                                    pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                    message: `Please enter correct format MM/DD/YYYY Pattern`
                                }
                            ],
                        })(
                            // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
                            <InputMask
                                mask="99/99/9999"
                                placeholder='MM/DD/YYYY'
                                style={{ borderRadius: 5 }}
                                alwaysShowMask
                                maskChar={null}
                                onBlur={(e) => this.CheckTheDate(e.target.value, 1)}
                                className="ant-input"
                                render={(ref, props) => (
                                    <Input />
                                )}
                            />
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem
                        label="Email"
                        hasFeedback
                        style={{padding: '0px'}}
                    >
                        {getFieldDecorator('email', {
                            rules: [{ required: true, type: "email", message: 'Enter valid email address!' }],
                        })(
                            <Input placeholder="Email" />
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                <FormItem hasFeedback
                    label={'Phone'}
                >
                    {getFieldDecorator('phone', {
                        rules: [{ required: true, min: 10, max: 15, message: 'Must be between 10 and 15 characters!' },
                        { pattern: new RegExp("^[0-9]*$"), message: 'Enter only Numeric!' }],
                    })(
                        <Input placeholder="Phone" />
                    )}
                </FormItem>
                </Col>
                <Col span={12}>
                <FormItem hasFeedback
                    label='Member ID'>
                        {getFieldDecorator('memberID',{
                        rules: [{ required: true, max: 15, message: 'Must be below 15 characters!' },
                        { pattern: new RegExp("^[0-9]*$"), message: 'Enter only Numeric!' }],
                    })(
                            <Input placeholder="Member ID" />
                        )}
                </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem
                        label="Computer Type (PC, phone, tablet)"
                        style={{padding: '0px'}}
                    >
                        {getFieldDecorator('computerType', {
                            rules: [{ required: true, message: 'Enter Your Computer Type!' }],
                        })(
                            <Select
                            // onChange={this.handleHomeChange}
                            showSearch
                            style={{ width: '100%' }}
                            // placeholder="Select a computer type"
                            optionFilterProp="children"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.renderComputerType()}
                        </Select>
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem
                        label="Browser"
                        style={{padding: '0px'}}
                    >
                        {getFieldDecorator('browser', {
                            rules: [{ required: true, message: 'Enter Browser!' }],
                        })(
                            <Input maxLength={50}  />
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem
                        label="Area of Concern"
                        style={{padding: '0px'}}
                    >
                        {getFieldDecorator('areaOfConcern', {
                            rules: [{ required: true, message: 'Select Your Area of Concern!' }],
                        })(
                            <Select
                            // onChange={this.handleHomeChange}
                            showSearch
                            style={{ width: '100%' }}
                            // placeholder="Select a Area of Concern"
                            optionFilterProp="children"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.renderAreaOfConcern()}
                        </Select>
                        )}
                    </FormItem>
                </Col>
                {/* <Col span={12}>
                            <FormItem
                                label="Payment Mode"
                            >
                                {getFieldDecorator('payment_mode', {
                                    rules: [{ required: true, message: 'Enter Membership Payment Mode!' }],
                                })(
                                    <Input placeholder="Payment Mode" />
                                )}
                            </FormItem>
                        </Col> */}
                <Col span={12}>
                    <FormItem
                        label="Type of issue"
                        style={{padding: '0px'}}
                    >
                        {getFieldDecorator('typeOfIssue', {
                            rules: [{ required: true, message: 'Select Your Issue Type!' }], 
                        })(
                            <Select
                            // onChange={this.handleHomeChange}
                            showSearch
                            style={{ width: '100%' }}
                            // placeholder="Select a type of issue"
                            optionFilterProp="children"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.renderTypeOf_Issue()}
                        </Select>
                        )}
                    </FormItem>
                </Col>

                <Col span={24}>
                    <FormItem
                        label={<div>
                            <Col span={20}>
                                Please provide details regarding your issue.
                            </Col>
                            <Col span={4} style={{textAlign: 'end', fontSize: '12px'}}>
                                {this.state.briefDescription_textLength}/500
                            </Col>
                        </div>}
                        style={{padding: '0px'}}
                    >
                        {getFieldDecorator('briefDescription', {
                            rules: [{ required: false, message: 'Enter Brief Description of the issue!' }],
                        })(
                            <TextArea  rows={4} maxLength={500} onChange={(e) => this.getTextCount(e)}/>
                        )}
                    </FormItem>
                </Col>
                {/* <Col span={12}> */}
                    {/* <Form.Item
                        className="input"
                        
                        name="checkPic"
                        label="NOTE:  Please provide a screen shot if necessary to explain the issue."
                        rules={[
                            {

                                message: "Upload Screenshot",
                            },
                        ]
                    }
                    style={{padding: '0px'}}
                    >
                        <Dragger
                            // accept=".jpg,.jpeg,.png"
                            className="profile-pic-uploader"
                            name="file"
                            listType="file"
                            // defaultFileList={this.state.defaultFileList}
                            // showUploadList={false}
                            customRequest={dummyRequest}
                            beforeUpload={beforeUpload}
                            onChange={this.handleChange}
                        >
                            {/* NOTE:  Please provide a screen shot if necessary to explain the issue. */}
                            {/* <p className="ant-upload-drag-icon">
                                <Icon type="inbox" />
                            </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>

                        </Dragger>
                    </Form.Item>
                </Col> */} 
            </Row>
            <Row type="flex" justify="space-between">
                <Col xs={24} sm={24} md={10} lg={10}>
                    <FormItem>
                        <Button className="form-cancel-btn modal-btn" onClick={this.props.hideSPARK_OpportunityModalHandler}> Cancel </Button>
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={10} lg={10}>
                    <FormItem>
                        <Button loading={this.props.loading ? true : false} className="form-submit-btn modal-btn" htmlType="submit"> Submit </Button>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </Modal>
    }
}


function mapStateToProps(state) {
    return {
        isadmin: state.isadminreducer.isadmin,
        isspecialist: state.isadminreducer.isspecialist,
        isSendingMail: state.sparkOpportunityFormReducer.isSendingMail,
        mailSent: state.sparkOpportunityFormReducer.mailSent,
        mailFailed: state.sparkOpportunityFormReducer.mailFailed,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Form.create()(SparkOpportunityForm));



// WEBPACK FOOTER //
// ./src/components/Inc/SparkOpportunityForm.js